module.exports = __webpack_public_path__ + "static/img/modallook.b769b4d1.png";